
export const SUPPLIERS_FILE = 'supplier.json';
export const SUPPLIERS_FILE_PREFIX =  "supplier_";
export const INDUSTRIES_FILE = 'industries.json';
export const INDUSTRIES_FILE_PREFIX = 'industries_';
export const GEOGRAPHIES_FILE = 'geographies.json';
export const GEOGRAPHIES_FILE_PREFIX = 'geographies_';
export const PRODUCTS_AND_SERVICES_FILE = 'productsAndServices.json';
export const PRODUCTS_AND_SERVICES_FILE_PREFIX = 'productsAndServices_';